var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tripctxmenu-container"},[_c('vs-button',{attrs:{"size":"large","block":"","transparent":""},on:{"click":function($event){return _vm.callback('delete')}}},[_c('img',{staticStyle:{"width":"17px","height":"17px"},attrs:{"src":require("../../assets/icons/ctx/delete.png")}}),_vm._v(_vm._s(_vm.$t('common.delete'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }